export const createStepTitleId = (index: number, wizardId: string) =>
	`step-${index}-${wizardId}-title`;
